/** Recently-viewed listings, kept client-side in localStorage. */

export interface RecentlyViewedItem {
  id: string;
  url: string;
  address: string;
  city: string;
  price: number;
  thumb?: string;
  viewedAt: number;
}

const KEY = 'goreal:recently-viewed';
const MAX = 12;

export function getRecentlyViewed(): RecentlyViewedItem[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentlyViewedItem[];
    return Array.isArray(parsed) ? parsed.filter((i) => i && i.id && i.url) : [];
  } catch {
    return [];
  }
}

export function recordView(item: Omit<RecentlyViewedItem, 'viewedAt'>): void {
  try {
    const list = getRecentlyViewed().filter((i) => i.id !== item.id);
    list.unshift({ ...item, viewedAt: Date.now() });
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    // storage unavailable — feature silently off
  }
}
